import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import {
  GET_ANSWER_AGENT_PROFILE, GET_QUOTE_FUNNEL_SESSION_ID, QUOTE_FUNNEL_QUESTIONS, UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS,
} from "./actionTypes"

import {
  getAnswerAgentProfileSuccess,
  getAnswerAgentProfileError,
  getQuoteFunnelQuestionsSuccess,
  getQuoteFunnelQuestionsError,
  updateQuoteFunnelQuestionsWithAnswersSuccess,
  updateQuoteFunnelQuestionsWithAnswersError,
  getQuoteFunnelSessionIdError,
  updateQuoteFormVisitSuccess,
} from "./actions"
import { AppConfiguration } from "config"
import { genericGetRequest, genericPostRequest } from "helpers/sf_backend_helper"

function* onGetAnswersAgentProfile({ payload }) {
  try {
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/get_agent_profile_by_session_id`;
    const request_body = payload;
    const request_headers = { "Content-type": "application/json" }
    // TODO: Replace Account ID
    let response = yield call(genericGetRequest, URL, request_body, request_headers)
    yield put(getAnswerAgentProfileSuccess(response))
  } catch (error) {
    yield put(getAnswerAgentProfileError(error))
  }
}

function* onGetQuoteFunnelQuestions({ payload }) {
  try {
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/get_prefill_data_by_session_id`;
    const request_body = payload
    const request_headers = { "Content-type": "application/json" }
    let response = yield call(genericGetRequest, URL, request_body, request_headers)
    if (payload?.reducer_update_not_required) {
      yield put(updateQuoteFormVisitSuccess(response))
      return
    }
    yield put(getQuoteFunnelQuestionsSuccess(response))
  } catch (error) {
    yield put(getQuoteFunnelQuestionsError(error))
  }
}

function* onUpdateQuoteFunnelQuestionsWithAnswers({ payload: { payload, additional_info, history } }) {
  try {
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/edit_prefill_query`;
    const request_body = { ...payload, preview: additional_info?.preview ? true : false, additional_info: additional_info };
    const request_headers = { "Content-type": "application/json" }
    const response = yield call(
      genericPostRequest,
      URL,
      {
        headers: request_headers,
        body: JSON.stringify(request_body),
      }
    )
    yield put(updateQuoteFunnelQuestionsWithAnswersSuccess(response));
    const location = window.location.pathname;
    if (additional_info?.review == 2) {
      history.push(`/forms/thank_you/session/${additional_info?.session_id}`)
    } else if (additional_info?.review == 1) {
      history.push(`/forms/review/session/${additional_info?.session_id}`)
    } else {
      history.push(`${location}?page_group_current_index=${additional_info?.page_group_current_index || ''}&page_current_index=${additional_info?.page_current_index || ''}&preview=${additional_info?.preview}`);
    }
  } catch (error) {
    yield put(updateQuoteFunnelQuestionsWithAnswersError(error))
  }
}

function* onGetQuoteFunnelSessionId({ payload, history }) {
  try {
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/create_prefill_query_by_campaign_id`;
    const request_headers = {
      "Content-type": "application/json"
    }
    const request_body = {
      headers: request_headers,
      body: JSON.stringify(payload),
    }
    const { redirect_url } = yield call(genericPostRequest, URL, request_body)
    let R_URL = redirect_url
    if (payload?.preview) {
      R_URL = redirect_url + '?preview=' + payload?.preview
    }
    window.location.href = R_URL
  } catch (error) {
    yield put(getQuoteFunnelSessionIdError(error))
  }
}

function* QuoteFunnelAnswersAgentProfileSaga() {
  yield takeEvery(GET_ANSWER_AGENT_PROFILE, onGetAnswersAgentProfile)
  yield takeEvery(QUOTE_FUNNEL_QUESTIONS, onGetQuoteFunnelQuestions)
  yield takeEvery(UPDATE_QUOTE_FUNNEL_QUESTIONS_WITH_ANSWERS, onUpdateQuoteFunnelQuestionsWithAnswers)
  yield takeEvery(GET_QUOTE_FUNNEL_SESSION_ID, onGetQuoteFunnelSessionId)
}

export default QuoteFunnelAnswersAgentProfileSaga